import React from 'react';
import { useTheme } from '../../shared/lib/themeContext';
import * as S from './SettingsPage.styles';

export const SettingsPage: React.FC = () => {
  const { mode, setTheme } = useTheme();

  return (
    <S.SettingsPageContainer>
      <S.SettingsHeader>
        <S.SettingsTitle>Настройки</S.SettingsTitle>
      </S.SettingsHeader>

      <S.SettingsContent>
        <S.SettingsSection>
          <S.SettingsSectionTitle>Внешний вид</S.SettingsSectionTitle>
          
          <S.SettingItem>
            <S.SettingLabel>
              <S.SettingLabelText>Тема оформления</S.SettingLabelText>
              <S.SettingDescription>
                Выберите светлую или темную тему
              </S.SettingDescription>
            </S.SettingLabel>
            
            <S.ThemeToggleContainer>
              <S.ThemeOption
                $active={mode === 'light'}
                onClick={() => setTheme('light')}
              >
                <S.ThemeOptionLabel>Светлая</S.ThemeOptionLabel>
              </S.ThemeOption>
              
              <S.ThemeOption
                $active={mode === 'dark'}
                onClick={() => setTheme('dark')}
              >
                <S.ThemeOptionLabel>Темная</S.ThemeOptionLabel>
              </S.ThemeOption>
            </S.ThemeToggleContainer>
          </S.SettingItem>
        </S.SettingsSection>
      </S.SettingsContent>
    </S.SettingsPageContainer>
  );
};

